import { useMutation } from "react-query";
import getIspv from "../services/getIspv";

function useGetIspv() {
  return useMutation(["get-ispv"], getIspv);
}

export default useGetIspv;
